import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// Stable per-tab session id (anonymous)
const SESSION_KEY = 'wa_session_id';
let sessionId = sessionStorage.getItem(SESSION_KEY);
if (!sessionId) {
  sessionId = Math.random().toString(36).slice(2) + Date.now().toString(36);
  sessionStorage.setItem(SESSION_KEY, sessionId);
}

const EXCLUDE_PREFIXES = ['/admin', '/portal'];  // don't track admin or portal paths

/**
 * Mount-once hook that listens to route changes and POSTs a tracking event.
 * Use inside <BrowserRouter> tree, e.g. inside <App/> root component.
 */
const usePageTracking = () => {
  const location = useLocation();
  useEffect(() => {
    const path = location.pathname;
    if (!path) return undefined;
    if (EXCLUDE_PREFIXES.some(p => path.startsWith(p))) return undefined;
    // Debounce so back/forward/redirects don't inflate counter
    const timer = setTimeout(() => {
      axios.post(`${API_URL}/api/analytics/track`, {
        path,
        session_id: sessionId,
        title: document.title,
        referer: document.referrer || null,
      }, { timeout: 5000 }).catch(() => {});
    }, 350);
    return () => clearTimeout(timer);
  }, [location.pathname]);
};

export default usePageTracking;
